import { useAtomValue, useSetAtom } from 'jotai';
import React, { useEffect } from 'react';

import {
  forceRefreshStatusAtom,
  forceRerenderUIAtom,
  repositoriesDataAtom,
  repositoriesStatusDataAtom,
} from './state';
import { forceReloadAccountsAtom } from '../Accounts/state';

const StatusUpdater = () => {
  const listingData = useAtomValue(repositoriesDataAtom);
  const statusListingData = useAtomValue(repositoriesStatusDataAtom);
  const setStatusForceRefresh = useSetAtom(forceRefreshStatusAtom);
  const setForceRerenderUI = useSetAtom(forceRerenderUIAtom);
  const setForceReloadAccountsData = useSetAtom(forceReloadAccountsAtom);

  useEffect(() => {
    // Set up a recurring timer to force reload repo data every 20 seconds
    const intervalId = setInterval(
      () => setStatusForceRefresh(Math.random().toString()),
      20000,
    );

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array ensures this effect runs only once on component mount

  useEffect(() => {
    const rows = listingData?.results;
    const statusRows = statusListingData;
    if (rows && statusRows) {
      // update the status in the listing data
      rows.forEach((row) => {
        const statusRow = statusRows.find((r) => r.id === row.id);
        if (statusRow) {
          // console.log('Found status row with id: ' + statusRow.id);

          const fields = [
            'status',
            'status_history',
            'is_active',
            'account',
            'deactivated_at',
            'deactivated_by',
            'reactivated_at',
            'reactivated_by',
            'updated_at',
            'scan',
            'scan_in_progress',
            'last_commit_date',
            'languages',
          ];

          // update the data
          fields.forEach((field) => {
            row[field] = statusRow[field];
          });
        }
      });
      setForceRerenderUI(Math.random().toString());
      setForceReloadAccountsData(Math.random().toString());
    }
  }, [statusListingData]);

  return <></>;
};

export default StatusUpdater;
